import * as React from 'react';
import { DataTable } from 'react-native-paper';
import { FlatList, ScrollView, Platform, View, Text, Image, Dimensions } from 'react-native';
import { Spinner, Thumbnail, Icon } from 'native-base';
import XDate from 'xdate';

export default function Table({
	cols,
	data,
	loadMoreData,
	sort,
	direction,
	setSort,
	colAlt,
	rowAlt,
	selectedId,
	onRowPress,
	loading,
	refreshing,
	dataInProperty,
	selectedItemRow,
	CustomIcon,
	smallWidth = 450
}) {
	const ITEM_HEIGHT = 48;
	const [height, setHeight] = React.useState(0);
	const hasScroll = height < data.length * ITEM_HEIGHT;
	const { width } = Dimensions.get('window');
	const isSmall = width <= smallWidth;
	const padding = isSmall ? 0 : 2;
	//console.log('scroll: ', hasScroll);
	//, sort == dataCol.name && (i > 0 ? { marginLeft: 16 } : { marginRight: 16 })
	const renderItem = React.useCallback(
		({ index, item }) => {
			const itemData = !!dataInProperty ? item[dataInProperty] : item;
			return (
				<>
					<DataTable.Row
						style={[{ height: ITEM_HEIGHT }, rowAlt && index % 2 && { backgroundColor: rowAlt }, selectedId && selectedId == item.id && { backgroundColor: '#b4d0e0' }]}
						onPress={!!onRowPress ? () => onRowPress(selectedId && selectedId == item.id ? null : item) : undefined}
						onPressOut={!!onRowPress ? () => onRowPress(selectedId && selectedId == item.id ? null : item) : undefined}
						onLongPress={!!onRowPress ? () => onRowPress(selectedId && selectedId == item.id ? null : item) : undefined}>
						{cols.map(
							(dataCol, i) =>
								!(isSmall && dataCol.hideSmall && !dataCol.avatar) &&
								dataCol.visible !== false && (
									<DataTable.Cell
										numeric={dataCol.numeric}
										key={index + dataCol.name}
										style={[
											{
												width: (isSmall && dataCol.widthSmall) || dataCol.width,
												flex: !dataCol.hideSmall ? dataCol.flex : null,
												backgroundColor: i % 2 && colAlt,
												borderColor: '#CFCFCF',
												borderRightWidth: dataCol.borderRight || 0,
												paddingLeft: padding,
												paddingRight: padding
											},
											dataCol.style
										]}>
										{!!dataCol.avatar && typeof dataCol.avatar == 'function' && <Image style={{ height: 30, width: 30 }} source={{ uri: dataCol.avatar(itemData[dataCol.name]) }} />}
										{!!dataCol.avatar && typeof dataCol.avatar == 'string' && !!itemData[dataCol.avatar] && (
											<Image style={{ height: 24, width: 24, paddingTop: -20 }} source={{ uri: 'data:image/png;base64,' + itemData[dataCol.avatar] }} />
										)}
										{!!dataCol.icon && !dataCol.iconFont && typeof dataCol.icon == 'string' && !!itemData[dataCol.icon] && (
											<Icon name={itemData[dataCol.icon]} style={{ height: 30, width: 30, color: itemData[dataCol.iconColour] }} />
										)}
										{!!dataCol.icon && !!dataCol.iconFont && typeof dataCol.icon == 'string' && !!itemData[dataCol.icon] && (
											<CustomIcon style={{ fontSize: 24, color: itemData[dataCol.iconColour] }} name={itemData[dataCol.icon]} />
										)}
										{!dataCol.hideText && !(isSmall && dataCol.hideSmall) && (
											<Text
												style={{
													fontSize: 12,
													marginLeft: 0,
													alignSelf: 'center'
												}}>
												{!dataCol.renderer && itemData[dataCol.name]}
												{!!dataCol.renderer && typeof dataCol.renderer == 'function' && dataCol.renderer(itemData[dataCol.name])}
												{!!dataCol.renderer && dataCol.renderer == 'date' && XDate(itemData[dataCol.name]).toString('dd/MM/yyyy')}
												{!!dataCol.renderer && dataCol.renderer == 'money' && itemData[dataCol.name].toFixed(2)}
											</Text>
										)}
									</DataTable.Cell>
								)
						)}
					</DataTable.Row>
					{!!selectedId && selectedId == item.id && !!selectedItemRow && selectedItemRow(item)}
				</>
			);
		},
		[rowAlt, selectedId, onRowPress, cols, dataInProperty, selectedItemRow, isSmall]
	);

	return (
		<>
			<DataTable>
				<DataTable.Header>
					{cols.map(
						(col, colI) =>
							!(isSmall && col.hideSmall && !col.avatar) &&
							col.visible !== false && (
								<DataTable.Title
									key={colI}
									numeric={col.numeric}
									style={[{ width: (isSmall && col.widthSmall) || col.width, flex: !col.hideSmall ? col.flex : null, paddingLeft: padding, paddingRight: padding }, col.style]}
									sortDirection={sort == col.name ? direction : undefined}
									onPress={col.sortable ? () => setSort(col.name) : undefined}>
									{col.title}
								</DataTable.Title>
							)
					)}
					{hasScroll && Platform.OS == 'web' && <View style={{ width: 17 }} />}
				</DataTable.Header>
			</DataTable>
			{loading && <Spinner />}
			<FlatList
				style={{ flex: 1 }}
				data={data}
				initialNumToRender={25}
				onLayout={e => setHeight(e.nativeEvent.layout.height)}
				//getItemLayout={this.getItemLayout}
				//refreshing={data.networkStatus === 4}
				//onRefresh={() => data.refetch()}
				//FlatListItemSeparator={() => <View style={styles.line} />}
				//onEndReachedThreshold={8}
				getItemLayout={(data, index) => ({ length: ITEM_HEIGHT, offset: ITEM_HEIGHT * index, index })}
				onEndReached={loadMoreData}
				renderItem={renderItem}
				keyExtractor={item => (dataInProperty ? item[dataInProperty].id : item.id)}
				onEndReachedThreshold={0.7}
				refreshing={refreshing}
				extraData={selectedId}

				//ListFooterComponent={this.renderFooter}
				//maxToRenderPerBatch={16}
				//windowSize={16}
			/>
		</>
	);
}
